import { createSelector } from '@reduxjs/toolkit';

import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectModelsByIdSelector } from 'src/selectors/projectModelsById';

export const projectModelSelector = memoizeSelectorFactory(
  (projectId: string, id: string) =>
    createSelector(
      projectModelsByIdSelector(projectId),
      (modelsById) => modelsById[id] || null
    )
);
